import { isBarcodeOpenAtom } from '@atoms/barcodeAtoms';
import AppModal from '@components/AppModal';
import Column from '@components/Column';
import CustomBarcode from '@components/CustomBarcode';
import Row from '@components/Row';
import Switch from '@components/Switch';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { setBarcodeDialogOpen } from '@utils/nativeUtils';
import { useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        BarcodeModal: {};
    }
}

const BarcodeModal: ActivityComponentType<'BarcodeModal'> = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('barcode');
    const [enabled, setEnabled] = useState<boolean>(false);
    const setBarcode = (value: boolean) => {
        window.localStorage.setItem('useBarcode', value.toString());
        setEnabled(value);
        setBarcodeDialogOpen(value);
    };
    useEffect(() => {
        setEnabled(window.localStorage.getItem('useBarcode') === 'true');
    }, []);
    const setIsBarcodeOpen = useSetAtom(isBarcodeOpenAtom);
    const close = () => {
        setIsBarcodeOpen(false);
        pop();
    };
    const { user } = useUser();
    return (
        <AppModal title={t('title')}
            confirm={t('close')}
            onConfirm={close}
            disableOutside >
            {/* 툴팁은 바코드 바로 위에 뜨도록 바코드 묶음을 기준으로 배치한다 */}
            <BarcodeArea spacing={4} align='center' fullWidth>
                <Tooltip visibleKey='barcode'
                    top={-52}
                    left='unset'
                    right='unset'
                    bottom={12} >
                    {t('tooltip')}
                </Tooltip>
                <CustomBarcode value={user?.barcodeNo || ''}
                    height={48} />
                <Text size='body-long' color={colors.textPrimary}>
                    {user?.barcodeNo.match(/.{1,4}/g)?.join(' ')}
                </Text>
            </BarcodeArea>
            <Row spacing={2}
                align='center'
                justify='center'
                fullWidth>
                <Text size='body-long' fontWeight='medium' color={colors.textSecondary}>
                    {t('shakeSetting')}
                </Text>
                <Switch checked={enabled}
                    setChecked={setBarcode} />
            </Row>
        </AppModal>
    );
};

const BarcodeArea = styled(Column)`
    position: relative;
`;

export default BarcodeModal;
